'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _dec4, _class6, _class7, _temp3;
// import {Row, Col} from 'react-flexbox-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _PlanScorecardIssueAllocations = require('./PlanScorecardIssueAllocations.css');

var _PlanScorecardIssueAllocations2 = _interopRequireDefault(_PlanScorecardIssueAllocations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardIssueAllocationsTableHead = (_dec = (0, _reactCssModules2.default)(_PlanScorecardIssueAllocations2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardIssueAllocationsTableHead, _Component);

  function PlanScorecardIssueAllocationsTableHead(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardIssueAllocationsTableHead);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardIssueAllocationsTableHead.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardIssueAllocationsTableHead)).call(this, props));
  }

  (0, _createClass3.default)(PlanScorecardIssueAllocationsTableHead, [{
    key: 'render',
    value: function render() {
      var headLabel = this.props.headLabel;
      //

      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { colSpan: '5' },
            _react2.default.createElement(
              'div',
              { styleName: 'th main-table-heading' },
              _react2.default.createElement(
                'b',
                null,
                headLabel
              ),
              ' ',
              _react2.default.createElement(_components.XsBr, null),
              'scorecard'
            )
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('th', null),
          _react2.default.createElement(
            'th',
            null,
            'Target date funds'
          ),
          _react2.default.createElement(
            'th',
            null,
            'Equity funds'
          ),
          _react2.default.createElement(
            'th',
            null,
            'Total flagged'
          ),
          _react2.default.createElement(
            'th',
            null,
            '% of plan assets'
          )
        )
      );
    }
  }]);
  return PlanScorecardIssueAllocationsTableHead;
}(_react.Component), _class2.propTypes = {
  headLabel: _react.PropTypes.string
}, _temp)) || _class);
var PlanScorecardIssueAllocationsTableRow = (_dec2 = (0, _reactCssModules2.default)(_PlanScorecardIssueAllocations2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(PlanScorecardIssueAllocationsTableRow, _Component2);

  function PlanScorecardIssueAllocationsTableRow(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardIssueAllocationsTableRow);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardIssueAllocationsTableRow.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardIssueAllocationsTableRow)).call(this, props));
  }

  (0, _createClass3.default)(PlanScorecardIssueAllocationsTableRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iyvCode = _props.iyvCode,
          shrtLbl = _props.shrtLbl,
          lngLbl = _props.lngLbl,
          screenResults = _props.screenResults;

      var icon = require('../../../static/images/icons/' + iyvCode + '-icon.svg');
      //
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'alloc-icn-lbl' },
            _react2.default.createElement(
              'div',
              { styleName: 'result-lbl-icon-bbl' },
              _react2.default.createElement('img', {
                styleName: 'result-lbl-icon',
                src: icon,
                alt: shrtLbl
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'alloc-icn-lbl-txt' },
              lngLbl
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          screenResults[iyvCode].td
        ),
        _react2.default.createElement(
          'td',
          null,
          screenResults[iyvCode].eq
        ),
        _react2.default.createElement(
          'td',
          null,
          screenResults[iyvCode].tot
        ),
        _react2.default.createElement(
          'td',
          null,
          screenResults[iyvCode].perc
        )
      );
    }
  }]);
  return PlanScorecardIssueAllocationsTableRow;
}(_react.Component), _class4.propTypes = {
  iyvCode: _react.PropTypes.string,
  shrtLbl: _react.PropTypes.string,
  lngLbl: _react.PropTypes.string,
  screenResults: _react.PropTypes.object
}, _temp2)) || _class3);
var PlanScorecardIssueAllocationsNoData = (_dec3 = (0, _reactCssModules2.default)(_PlanScorecardIssueAllocations2.default, { allowMultiple: true }), _dec3(_class5 = function (_Component3) {
  (0, _inherits3.default)(PlanScorecardIssueAllocationsNoData, _Component3);

  function PlanScorecardIssueAllocationsNoData() {
    (0, _classCallCheck3.default)(this, PlanScorecardIssueAllocationsNoData);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardIssueAllocationsNoData.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardIssueAllocationsNoData)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanScorecardIssueAllocationsNoData, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'plan-option-card' },
        _react2.default.createElement(
          'h3',
          { styleName: 'allocation-subtitle' },
          'This plan is missing allocation data.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We have data on the fund options offered to plan participants, but no data on how much is invested in each fund option, or the overall amount invested in risk categories like fossil fuels, deforestation-risk agribusiness, or arms manufacturers. This can happen when a plan updates their investment options, but a new ',
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.routes.faqs + '#where-does-the-data-for-my-retirement-plan-scorecard-come-from-',
              xstrong: true,
              title: 'Where does the data for my retirement plan scorecard come from?'
            },
            'Form 5500'
          ),
          ' has not yet been filed. Check back soon to see if allocation data for this fund has been added.'
        )
      );
    }
  }]);
  return PlanScorecardIssueAllocationsNoData;
}(_react.Component)) || _class5);
var PlanScorecardIssueAllocations = (_dec4 = (0, _reactCssModules2.default)(_PlanScorecardIssueAllocations2.default, { allowMultiple: true }), _dec4(_class6 = (_temp3 = _class7 = function (_Component4) {
  (0, _inherits3.default)(PlanScorecardIssueAllocations, _Component4);

  function PlanScorecardIssueAllocations(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardIssueAllocations);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardIssueAllocations.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardIssueAllocations)).call(this, props));

    _this4.state = {
      showFullAllocationTable: false
    };
    return _this4;
  }

  //


  (0, _createClass3.default)(PlanScorecardIssueAllocations, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!this.props.planData) {
        return null;
      }
      var planData = this.props.planData;

      // if no allocation data for plan

      if (planData.allocations.default === 0) {
        return _react2.default.createElement(PlanScorecardIssueAllocationsNoData, null);
      }

      // chart image
      var hasAllocationChartImg = false;
      var allocationChartUrl = null;
      var allocationChartImg = null;
      try {
        allocationChartImg = require('../../../static/images/charts/' + planData.path + '_' + planData.year + '_chart.png');
        allocationChartUrl = _config2.default.domain + '/images/charts/' + planData.path + '_' + planData.year + '_chart.png';
        hasAllocationChartImg = true;
      } catch (e) {
        console.log('');
      }

      // map results from planData to a screenResults object
      var lbls = ['fff', 'dff', 'gff', 'pff', 'wff', 'tff'];
      var screenResults = {};
      for (var i = 0; i < lbls.length; i++) {
        var lbl = lbls[i];
        screenResults[lbl] = {
          eq: _format2.default.money(planData.screen_results[lbl][0], true, 'USD', true, 0),
          td: _format2.default.money(planData.screen_results[lbl][1], true, 'USD', true, 0),
          tot: _format2.default.money(planData.screen_results[lbl][0] + planData.screen_results[lbl][1], true, 'USD', true, 0),
          perc: _format2.default.perc((planData.screen_results[lbl][0] + planData.screen_results[lbl][1]) / planData.plan_assets)
        };
      }

      var environmentConfig = [['fff', 'Fossil fuels', 'Fossil fuels'], ['dff', 'Deforestation', 'Deforestation-risk agribusiness commodity producer/traders']];

      var socialConfig = [['gff', 'Civilian firearms', 'Civilian firearms manufacturers'], ['pff', 'Prison industrial complex', 'Prison industrial complex, high risk'], ['wff', 'Military weapons', 'Arms manufacturers and military contractors'], ['tff', 'Tobacco', 'Tobacco producer/manufacturers']];

      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'plan-option-card' },
          _react2.default.createElement(
            'h2',
            { styleName: 'allocation-subtitle' },
            'This retirement plan has millions of dollars invested in fossil fuels, deforestation-risk agribusiness, and arms manufacturers.'
          ),
          hasAllocationChartImg ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: allocationChartUrl,
                title: planData.primary_plan_name + ' flagged investments',
                targetBlank: true
              },
              _react2.default.createElement('img', {
                src: allocationChartImg,
                alt: planData.primary_plan_name + ' flagged investments',
                styleName: 'allocation-chart-img'
              }),
              _react2.default.createElement(
                'span',
                { styleName: 'allocation-chart-expand-label visible-xs' },
                'Click to enlarge',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-expand' })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'allocation-sublede' },
              'The figures in this chart and the tables below are calculated by cross-referencing annual data on  plan investments for ',
              planData.year,
              ' (using Form 5500 data filed ',
              planData.filing_received,
              ') and monthly data on mutual fund holdings from ',
              _config2.default.versionDate,
              '. The results represent a best-faith effort to measure plan participant exposure to various environmental and social risk screens using the most recent data available. The actual amount invested by the plan may be higher today as employees have made further contributions since ',
              planData.year,
              '. These results represent stock investments within the plan\'s target date and equity funds, and do not capture any risky investments in other fund types or through a self-directed option. The results also do not include any risky investments in target date options or equity fund options if those options are closed-end funds where we lack access to holdings, or collective trusts that we were unable to match to a suitable mutual fund as a stand-in. For more information, ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.methodology,
                  title: 'Methodology',
                  xstrong: true
                },
                'read our full methodology here.'
              )
            )
          ) : null
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'button',
          {
            styleName: 'section-slidedown-button',
            onClick: function onClick(e) {
              _this5.setState({
                showFullAllocationTable: !_this5.state.showFullAllocationTable
              });
            }
          },
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-label' },
            'Allocation details'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-icon' },
            _react2.default.createElement(_components.LinkIcon, {
              faclass: this.state.showFullAllocationTable ? 'fa-angle-up' : 'fa-angle-down'
            })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          this.state.showFullAllocationTable ? _react2.default.createElement(
            'div',
            null,
            this.props.planData.path === 'thrift_savings_plan' ? _react2.default.createElement(
              'div',
              { styleName: 'tsp-disclaimer' },
              _react2.default.createElement(
                'div',
                { styleName: 'tsp-disclaimer-icon' },
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' })
              ),
              _react2.default.createElement(
                'p',
                null,
                'Like most retirement plans, The Thrift Savings Plan is composed of target date funds, as well as individual equity and bond funds. But the Thrift Savings Plan is unique in that the target date L Funds are themselves composed of the individual C, S, I, F, and G funds. The figures below for the equity funds (the C, S, and I funds) have been adjusted to account for this, to avoid double counting. Any assets in the C, S, and I funds that are held via target date L funds are allocated to the target date lineup.'
              )
            ) : null,
            _react2.default.createElement(
              'div',
              { styleName: 'screen-results-table-wrap' },
              _react2.default.createElement(
                'table',
                { styleName: 'full-row-table' },
                _react2.default.createElement(PlanScorecardIssueAllocationsTableHead, {
                  headLabel: 'Environment'
                }),
                _react2.default.createElement(
                  'tbody',
                  null,
                  environmentConfig.map(function (e, i) {
                    return _react2.default.createElement(PlanScorecardIssueAllocationsTableRow, {
                      key: 'tr-e-' + i,
                      iyvCode: e[0],
                      shrtLbl: e[1],
                      lngLbl: e[2],
                      screenResults: screenResults
                    });
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'screen-results-table-wrap' },
              _react2.default.createElement(
                'table',
                { styleName: 'full-row-table' },
                _react2.default.createElement(PlanScorecardIssueAllocationsTableHead, {
                  headLabel: 'Social'
                }),
                _react2.default.createElement(
                  'tbody',
                  null,
                  socialConfig.map(function (e, i) {
                    return _react2.default.createElement(PlanScorecardIssueAllocationsTableRow, {
                      key: 'tr-s-' + i,
                      iyvCode: e[0],
                      shrtLbl: e[1],
                      lngLbl: e[2],
                      screenResults: screenResults
                    });
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'screen-results-table-post' },
              _react2.default.createElement(
                'h2',
                null,
                'Total plan assets analyzed: ',
                _react2.default.createElement(
                  'b',
                  null,
                  _format2.default.money(planData.plan_assets, true, 'USD', true, 1)
                ),
                ' invested in ',
                _react2.default.createElement(
                  'b',
                  null,
                  planData.plan_option_count
                ),
                ' plan options*'
              ),
              _react2.default.createElement(
                'p',
                null,
                '*Listed plan assets account only for investment options offered directly by the plan administrator, and don\'t include any assets invested in self-directed options, or any participant loans.'
              )
            )
          ) : null
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return PlanScorecardIssueAllocations;
}(_react.Component), _class7.propTypes = {
  planData: _react.PropTypes.object
}, _temp3)) || _class6);
exports.default = PlanScorecardIssueAllocations;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardIssueAllocations/PlanScorecardIssueAllocations.js
// module id = 1421
// module chunks = 0